import { render, staticRenderFns } from "./newAlbum.vue?vue&type=template&id=a6156a64&scoped=true&"
import script from "./newAlbum.vue?vue&type=script&lang=js&"
export * from "./newAlbum.vue?vue&type=script&lang=js&"
import style0 from "./newAlbum.vue?vue&type=style&index=0&id=a6156a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6156a64",
  null
  
)

export default component.exports